import React, { useCallback, useContext, useState } from 'react';
import { bool, func, number } from 'prop-types';
import { Button, Form } from 'react-bootstrap';

import { ToastContext } from './context/ToastContext';

import '../styles/QuestionReplyForm.css';

function QuestionReplyForm({ questionId, fetchAnswers, hasAnswers }) {
    const { sendMessage } = useContext(ToastContext);
    const [reply, setReply] = useState('');

    const handleReplyChange = useCallback((e) => {
        setReply(e.target.value);
    }, []);

    const onSubmit = useCallback(async (e) => {
        e.preventDefault();
        try {
            const url = new URL('/api/answers', process.env.APP_URL);
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    questionId: String(questionId),
                    answer: reply,
                }),
            });
            const { answer, error } = await response.json();
            if (error) {
                sendMessage(error, 'danger');
            }
            if (answer) {
                sendMessage('Reply added successfully', 'success');
                setReply('');
                await fetchAnswers();
            }
        } catch (e) {
            sendMessage(e.message, 'danger');
        }
    }, [questionId, reply, sendMessage, fetchAnswers]);

    return (
        <Form
            className={'question-reply--form'}
            onSubmit={onSubmit}
        >
            <Form.Group>
                <Form.Control
                    type={'text'}
                    placeholder={hasAnswers ? 'Reply to this question' : 'Be the first to reply!'}
                    value={reply}
                    onChange={handleReplyChange}
                    required
                />
            </Form.Group>
            <Button
                className={'question-reply--form--button'}
                type={'submit'}
            >
                Submit
            </Button>
        </Form>
    );
}

QuestionReplyForm.propTypes = {
    questionId: number,
    fetchAnswers: func,
    hasAnswers: bool,
};

export default QuestionReplyForm;